import { Link } from 'react-router-dom';
import { usePageMeta } from '../../hooks/usePageMeta';
import { useI18nLocaleSync } from '../../hooks/useI18nLocaleSync';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';

const ARTICLES = [
  {
    path: '/articles/how-powerball-works',
    title: 'How Powerball Works',
    description:
      'A complete guide to Powerball: how to play, prize tiers, jackpot odds, drawing process, lump sum vs. annuity, and taxes.',
  },
  {
    path: '/articles/understanding-lottery-odds',
    title: 'Understanding Lottery Odds',
    description:
      'A plain-English explanation of how Powerball, Mega Millions, and Lotto 6/45 odds are calculated, what expected value means, and why no strategy improves your chances.',
  },
  {
    path: '/articles/history-of-american-lotteries',
    title: 'History of American Lotteries',
    description:
      'From colonial-era fundraising through 19th-century scandal and bans to the modern era of Powerball and Mega Millions.',
  },
  {
    path: '/articles/how-rng-works',
    title: 'How Random Number Generators Work',
    description:
      'How PRNG algorithms work, why they are statistically fair for lottery use, and how lottery machines differ from software generators.',
  },
  {
    path: '/articles/responsible-lottery-play',
    title: 'Responsible Lottery Play',
    description:
      'Practical guidance on setting budgets, understanding expected value, recognizing problem gambling signs, and where to get help.',
  },
  {
    path: '/articles/korean-lotto-645',
    title: 'Korean Lotto 6/45 Guide',
    description:
      'Everything about Korean Lotto 6/45 (로또 6/45): how to play, prize tiers, jackpot odds, the drawing process, where to buy tickets, and historical jackpots.',
  },
];

export function ArticleIndex() {
  const lp = useLocalizedPath();
  useI18nLocaleSync();
  usePageMeta({
    title: 'Lottery Articles – Guides, Odds, History & Strategy | Lotto Number Generator',
    description:
      'In-depth articles on how lotteries work, how odds are calculated, the history of American lotteries, responsible play, and how random number generators work.',
    path: '/articles',
  });

  return (
    <main className="content">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to={lp('/')}>Home</Link>
        <span className="sep">/</span>
        <span className="current">Articles</span>
      </nav>

      <article className="about-section">
        <h1>Lottery Articles</h1>
        <p>
          In-depth guides on how lotteries work, the mathematics of odds, the history of American
          lotteries, responsible play practices, and the technology behind random number generators.
          All articles are written to be accurate, educational, and free of bias toward playing more.
        </p>

        <ul style={{ listStyle: 'none', padding: 0, margin: '24px 0 0 0' }}>
          {ARTICLES.map(({ path, title, description }) => (
            <li key={path} style={{ marginBottom: 24, paddingBottom: 24, borderBottom: '1px solid var(--border)' }}>
              <h2 style={{ fontSize: '1.1em', marginBottom: 6 }}>
                <Link to={path}>{title}</Link>
              </h2>
              <p style={{ margin: 0, lineHeight: 1.7, color: 'var(--text-secondary)' }}>{description}</p>
            </li>
          ))}
        </ul>

        <p style={{ marginTop: 16 }}>
          <Link to={lp('/')}>← Back to number generator</Link>
        </p>
      </article>
    </main>
  );
}
